<template>
  <div class="recent-actions">
    <div class="delete-all" @click="onDeleteAll">
      <font-awesome-icon icon="trash-alt" />
    </div>
    <div class="delete-label">
      {{ $t('recentItems.actions.labels.deleteRecentlyViewed') }}
    </div>
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/event-log/views/${userId}?limit=${currentPageLimit}`,
          searchKeys: ['initiatedAt', 'objectReferenceNumber', 'objectId']
        }"
        :results-in-dropdown="false"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
  </div>
</template>

<script>
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  RecentItemsGetters,
  RecentItemsActions
} from '@/app/features/recent-items/recent-items.keys';
export default {
  name: 'RecentActions',
  components: {
    TolTypeAhead
  },

  computed: {
    currentPageLimit() {
      return this.$store.getters[RecentItemsGetters.RecentItemsPerPage];
    },
    userId() {
      return this.$store.state.currentUser ? this.$store.state.currentUser.id : null;
    }
  },
  updated() {
    if (!this.userId) {
      this.userId = this.$store.state.currentUser.id;
    }
  },
  methods: {
    onFiltered(results) {
      this.$store.dispatch(RecentItemsActions.FilterRecentItems, {
        filteredItems: results.data,
        userId: this.userId,
        isSearchKey: results.isSearchKey
      });
    },
    onDeleteAll() {
      this.$store.dispatch(RecentItemsActions.DeleteRecentItems, {
        userId: this.userId,
        recentItemId: null,
        all: true
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../styles/colors.scss';
@import '../../../styles/variables.scss';

.recent-actions {
  display: flex;
  align-items: center;
  background-color: $background-level-2;
  padding: 60px;

  .search {
    margin-left: auto;
  }
  .delete-all {
    position: relative;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 100%;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      background-color: $light-grey-2;
      color: $red;
      cursor: pointer;
    }
  }
  .delete-label {
    margin-left: 5px;
    color: red;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: bold;
  }
}
</style>
